/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IPublicSuburbanV1GetOffersHistoryRequest,
  TPublicSuburbanV1GetOffersHistoryModel,
  IMappers,
  TPublicSuburbanV1GetOffersHistoryResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IOfferHistoryResponseDesktopV4 } from '../../../entities/offer_history/OfferHistoryResponseDesktopV4';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicSuburbanV1GetOffersHistoryModel(
  parameters: IPublicSuburbanV1GetOffersHistoryRequest,
): TPublicSuburbanV1GetOffersHistoryModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/suburban/v1/get-offers-history/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IPublicSuburbanV1GetOffersHistoryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicSuburbanV1GetOffersHistoryRequest;
}

export async function fetchPublicSuburbanV1GetOffersHistory<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1GetOffersHistoryOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicSuburbanV1GetOffersHistoryResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicSuburbanV1GetOffersHistoryModel(parameters),
    config,
  )) as FetchResponse<TPublicSuburbanV1GetOffersHistoryResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOfferHistoryResponseDesktopV4, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicSuburbanV1GetOffersHistoryResponse>;
}
